import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input
} from "reactstrap";
import { withState } from "recompose";
import ReactSVG from "react-svg";
import styled from "styled-components";
import config from "../config";

const Logo = require("../assets/images/tramite-express-logo-green.svg");

const burgerIcon = require("../assets/images/menu.svg");

const enhance = withState("isOpen", "toggle", false);
const Layout = enhance(({ isOpen, toggle, children }) => {
  return (
    <div>
      <StyledNavBar expand="lg" className="px-0">
        <div
          className="container header-boder">
          <NavbarBrand href="/">
            <ReactSVG path={Logo} svgStyle={{ width: "293px" }} />
          </NavbarBrand>
          <NavbarToggler onClick={() => toggle(!isOpen)} >
            <ReactSVG path={burgerIcon} svgStyle={{ width: "30px" }} />
          </NavbarToggler>
          <Collapse isOpen={isOpen} navbar>
            <StyledNav>
              <StyledNavItem>
                <NavLink href="/">HOME</NavLink>
              </StyledNavItem>
              <StyledNavItem>
                <NavLink href={`${config.contactoUrl}#preguntas-frecuentes`}>PREGUNTAS FRECUENTES</NavLink>
              </StyledNavItem>
              <StyledNavItem>
                <NavLink href={config.contactoUrl}>CONTACTO</NavLink>
              </StyledNavItem>
              <StyledNavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    OTROS TRÁMITES
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <NavLink href={config.f08Url}>
                        FORMULARIO 08 DIGITAL
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink href={config.cetaUrl}>CETA</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink href={config.caiUrl}>CAI</NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </StyledNavItem>
            </StyledNav>
          </Collapse>
        </div>
      </StyledNavBar>

      {children}

      <FooterStyled>
        <div className="container pb-0 pb-md-4">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="d-flex flex-grow-1">
              <a style={{ marginBottom: '23px' }} href="/" className="navbar-brand my-style-title bold-text">
                <img src={require('../assets/images/tramite-express-logo.svg')} alt="logo" style={{ width: '204px' }} />
              </a>
            </div>
            <div className="flex-grow-1 text-right menu-mobile" id="myNavbar">
              <ul className="navbar-nav ml-auto flex-nowrap">
                <li className="nav-item menu-item item-menu-footer">
                  <a style={{ color: "white" }} href={`${process.env.REACT_APP_TRAMITA_SITE}/terminos-uso`} className="nav-link m-2 menu-item item-menu-footer">Términos y condiciones de uso</a>
                </li>
                <li className="nav-item menu-item" >
                  <a style={{ color: "white" }} href={`${process.env.REACT_APP_TRAMITA_SITE}/politica-privacidad`} className="nav-link m-2 menu-item item-menu-footer">Políticas de privacidad</a>
                </li>
                <li className="nav-item menu-item" >
                  <a style={{ color: "white" }} href={`${process.env.REACT_APP_TRAMITA_SITE}/arrepentimiento/cedula%20azul`} className="nav-link m-2 menu-item item-menu-footer">Boton de Arrepentimiento</a>
                </li>
                <li className="nav-item menu-item item-menu-footer" >
                  <a style={{ color: "white" }} href="https://www.argentina.gob.ar/defensadelconsumidor" target="_blank" className="nav-link m-2 menu-item">Defensa al consumidor</a>
                </li>
                <li className="nav-item menu-item last-item">
                  <a style={{ color: "white" }} href={`${process.env.REACT_APP_TRAMITA_SITE}/contacto`} className="nav-link m-2 menu-item">Contacto</a>
                </li>
              </ul>
            </div>
          </nav>
          <div className="cointainer-footer-text mt-3">
            <div className="row align-items-center">
              <div className="col-md-5">
                <div className="row qr-code-style">
                  <a href="http://qr.afip.gob.ar/?qr=STYphOC-iv7piVbvBz6ETg,," target="_F960AFIPInfo">
                    <img style={{ width: '90px' }} src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg" border="0" />
                  </a>
                  <div className="text-location" style={{marginLeft: '15px'}}>
                    <p><strong>Vortex Labs SRL</strong> </p>
                    <p>Av de Mayo 881. Piso 7 oficina G, CABA. CP 1084,
                      Argentina</p>
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <p className="text-footer-right">LA AGENCIA DE ACCESO A LA INFORMACIÓN
                  PUBLICA, en su character de
                  Órgano de Control
                  de la Ley Nro. 25326, tiene la atribución de attender las denuncias
                  y reclamos que
                  interpongan
                  quienes resulten afectados en sus derechos por incumplimiento de las
                  normas vigentes
                  en materia de protección de datos personales.</p>
              </div>
            </div>
          </div>
        </div>
      </FooterStyled>
    </div>
  );
});

const StyledNav = styled(Nav)`
  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`

const StyledNavBar = styled(Navbar)`
  padding-top: 1em !important;
`;

const StyledNavItem = styled(NavItem)`
  font-family: "Montserrat";
  font-size: 14px;
  margin-left: 1em;
  margin-right: 1em;

  a {
    color: #333333;
  }

  @media screen and (max-width: 1366px) {
    font-size: 12px;
  }
`;

const FooterStyled = styled.footer`
  padding: 2em;
  background: #444;

  p {
    color: white;
    font-size: 13px;
    font-family: "Montserrat";
    font-weight: 500;
  }
`;

const StyledInput = styled(Input)`
  border: 1px solid #30bdbb !important;
  height: 30px !important;
  font-size: 10px;
  font-family: "Montserrat";
  border-radius: 15px !important;
`;

export default Layout;
